<!-- @format -->

<!-- tabindex makes the scrollable region reachable and scrollable with the keyboard -->
<section class="horizontal-timeline-scroll-container" tabindex="0" [attr.aria-labelledby]="labelledBy()">
  <div class="horizontal-timeline-track"></div>
</section>
